@layer design-system {
  @keyframes loading {
    from {
      background-position: 0 0;
    }
    to {
      background-position: -200% 0;
    }
  }

  @mixin viewWrapperShared {
    background-color: var(--surface-neutral);
    padding: 12px;
  }

  @mixin defaultShared {
    opacity: 0.35;
    background-image: linear-gradient(
      to right,
      var(--border-default),
      var(--border-soft) 85%,
      var(--border-soft),
      var(--border-default) 100%
    );
    background-size: 200%;
    animation: loading 1.4s infinite;
  }

  .wrapper {
    width: 100%;
    height: fit-content;
  }

  .wrapperWithWrapper {
    @include viewWrapperShared;
  }

  .wrapperDefaultView {
    @include viewWrapperShared;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .defaultTitle {
    @include defaultShared;
    width: 30%;
    height: 12px;
    border-radius: 100px;
    margin: 8px 0 24px;
  }

  .defaultContent {
    @include defaultShared;
    opacity: 0.1;
    border-radius: 10px;
    flex-grow: 1;
  }

  .area {
    @include defaultShared;
  }
}
